module.exports = __webpack_public_path__ + "img/Weapon_80.e4ecbbc0.png";